import * as Types from '../types-api.generated';

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiRemoveWorldShowcaseItemVariables = Types.Exact<{
  featuredItem: Types.ApiFeaturedItemByOneOfInput;
  worldId: Types.Scalars['Int'];
}>;


export type ApiRemoveWorldShowcaseItem = { removeWorldFeaturedItem: boolean };



export const ApiRemoveWorldShowcaseItemDocument = /*#__PURE__*/ `
    mutation RemoveWorldShowcaseItem($featuredItem: FeaturedItemByOneOfInput!, $worldId: Int!) {
  removeWorldFeaturedItem(featuredItem: $featuredItem, worldId: $worldId)
}
    `;

export const useRemoveWorldShowcaseItem = <
      TError = ClientError,
      TContext = unknown
    >(options?: UseMutationOptions<ApiRemoveWorldShowcaseItem, TError, ApiRemoveWorldShowcaseItemVariables, TContext>) => {
    
    return useMutation<ApiRemoveWorldShowcaseItem, TError, ApiRemoveWorldShowcaseItemVariables, TContext>(
      {
    mutationKey: ['RemoveWorldShowcaseItem'],
    mutationFn: (variables?: ApiRemoveWorldShowcaseItemVariables) => apiFetcher<ApiRemoveWorldShowcaseItem, ApiRemoveWorldShowcaseItemVariables>(ApiRemoveWorldShowcaseItemDocument, variables)(),
    ...options
  }
    )};


useRemoveWorldShowcaseItem.fetcher = (variables: ApiRemoveWorldShowcaseItemVariables, options?: RequestInit['headers']) => apiFetcher<ApiRemoveWorldShowcaseItem, ApiRemoveWorldShowcaseItemVariables>(ApiRemoveWorldShowcaseItemDocument, variables, options);
